module.exports = __webpack_public_path__ + "components/country-flag/static/gq-0dfbb131efbae575178331f5b387c03e.svg";